import { render, staticRenderFns } from "./Planejamento.vue?vue&type=template&id=52d3c908&scoped=true"
import script from "./Planejamento.vue?vue&type=script&lang=js"
export * from "./Planejamento.vue?vue&type=script&lang=js"
import style0 from "./Planejamento.vue?vue&type=style&index=0&id=52d3c908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d3c908",
  null
  
)

export default component.exports